<template>
<svg xmlns="http://www.w3.org/2000/svg" baseProfile="tiny" viewBox="0 0 102.84 98.82" :fill="color"><path d="M85.8 53.7H57c-.3 0-.6-.12-.83-.34l-6.24-5.98-6.24 5.98a1.19 1.19 0 0 1-.83.34h-28.8a1.22 1.22 0 0 1-1.12-.75c-.2-.45-.08-.98.26-1.33l31.06-31.2a1.23 1.23 0 0 1 .85-.35 1.2 1.2 0 0 1 .86.36l3.96 4.02 3.96-4.02c.23-.23.52-.4.86-.36a1.21 1.21 0 0 1 .85.35l31.06 31.2c.35.35.45.87.26 1.33a1.16 1.16 0 0 1-1.1.75m-28.33-2.43h25.4L54.74 23.02l-3.12 3.16 17.74 18c.47.48.47 1.24-.01 1.72-.47.47-1.24.47-1.7-.01L49.92 27.9 32.2 45.88c-.47.48-1.24.48-1.7.01-.48-.47-.48-1.24-.01-1.72l17.74-18-3.12-3.16-28.13 28.25h25.4l6.72-6.45c.47-.45 1.2-.45 1.67 0l6.72 6.45z"/><path d="M59.28 46.24c-.3 0-.6-.1-.83-.33l-8.53-8.12-8.52 8.12c-.48.46-1.25.44-1.7-.04-.46-.5-.44-1.26.04-1.72l9.25-8.8c.22-.22.52-.34.83-.34h.2a1.25 1.25 0 0 1 .84.33l9.25 8.8c.48.46.5 1.23.05 1.72-.24.26-.56.38-.88.38m-9.36 50.53c-26.44 0-47.95-21.6-47.95-48.14C1.97 22.08 23.48.5 49.92.5s47.95 21.6 47.95 48.14-21.5 48.14-47.95 48.14m0-91.67c-23.9 0-43.36 19.53-43.36 43.53S26 92.17 49.92 92.17s43.36-19.53 43.36-43.53S73.83 5.1 49.92 5.1m21.46 22.12c-2.6 0-4.72-2.13-4.72-4.74 0-2.62 2.12-4.74 4.72-4.74s4.72 2.13 4.72 4.74-2.12 4.74-4.72 4.74m0-7.05a2.31 2.31 0 1 0 0 4.62 2.31 2.31 0 1 0 0-4.62M82.1 62.86H17.74c-.6 0-1.1-.5-1.1-1.12 0-.6.5-1.12 1.1-1.12H82.1c.6 0 1.1.5 1.1 1.12a1.11 1.11 0 0 1-1.1 1.12m-6.27 7.52H24c-.6 0-1.1-.5-1.1-1.12 0-.6.5-1.12 1.1-1.12h51.82c.6 0 1.1.5 1.1 1.12s-.5 1.12-1.1 1.12m-11.66 8.6H35.68a1.11 1.11 0 0 1-1.11-1.12c0-.6.5-1.12 1.1-1.12h28.47c.6 0 1.1.5 1.1 1.12a1.1 1.1 0 0 1-1.1 1.12"/></svg>
</template>
<script>
export default {
  name: 'SvgLogo',
  props: {
    color: {
      type: String,
      default: '#fb342c'
    }
  },
  computed: {
  }
}
</script>
<style lang="scss" scoped>
svg{
  max-height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/SvgLogo/SvgLogo.vue